const embla = [];
window.addEventListener('load', function () {
	const sliderSettings = {
		align: 'start',
		containScroll: true,
		speed: 18,
	};
	const sliderEventsSettings = {
		align: 'start',
		containScroll: true,
		speed: 18,
	  active: true,
	  breakpoints: {
	    '(min-width: 768px)': { active: false },
	  },		
	};
	document.querySelectorAll('.embla').forEach((slider,index) => {
		const viewportNode = slider.querySelector('.embla__viewport');
		const prevButtonNode = slider.querySelector('.embla__prev');
		const nextButtonNode = slider.querySelector('.embla__next');
		const counterCurrent = slider.querySelector('.counter .current');
		const settings = (slider.classList.contains('type--events')) ? sliderEventsSettings : sliderSettings;
		// -- init --
		embla.push(EmblaCarousel(viewportNode, settings));
		// -- prev/next --
		(prevButtonNode) ? prevButtonNode.addEventListener('click', embla[index].scrollPrev, false) : null;
		(nextButtonNode) ? nextButtonNode.addEventListener('click', embla[index].scrollNext, false) : null;
		embla[index].on('init', function(){
			setTimeout(function(){
				var sliderContainer = embla[index].containerNode().closest('.embla.type--gallery');
				var imgHeight = embla[index].slideNodes()[0].querySelector('img').height;
				sliderContainer.style.maxHeight = imgHeight+'px';				
			},650);
		});
		embla[index].on('reInit', function(){
			var sliderContainer = embla[index].containerNode().closest('.embla.type--gallery');
			var imgHeight = embla[index].slideNodes()[0].querySelector('img').height;
			sliderContainer.style.maxHeight = imgHeight+'px';
		});
		embla[index].on('select', function(){
			// -- disable prev/next --
			(prevButtonNode) ? (embla[index].canScrollPrev()) ? prevButtonNode.removeAttribute('disabled') : prevButtonNode.setAttribute('disabled', 'disabled') : null;
			(nextButtonNode) ? (embla[index].canScrollNext()) ? nextButtonNode.removeAttribute('disabled') : nextButtonNode.setAttribute('disabled', 'disabled') : null;
			// -- update counter --
			(counterCurrent) ? counterCurrent.innerText = embla[index].selectedScrollSnap()+1 : null;
		});
	});
});